module.exports = __webpack_public_path__ + "img/nuxt.74e8b3b1.png";